import React from 'react'
import { Row, Col } from 'antd'
import Footer from '../../Footer'
import styles from './index.css'

const ContentWithSubSideBar = props => {
  const { subSideBar, children } = props
  return (
    <Row wrap={false}>
      <Col flex='210px'>
        <div
          className={styles.subSideBar}
        >
          {subSideBar}
        </div>
      </Col>
      <Col
        flex='auto'
        className={styles.rightContent}
      >
        <div className={styles.horizontalScroll}>
          <div className={styles.mainContent}>
            {children}
            <Footer />
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default ContentWithSubSideBar
